const Types = {
	SET_USER_MESSAGE: 'SET_USER_MESSAGE'
}

const initialState = {
	userMessage: ''
}

const setUserMessage = userMessage => ({
	payload: { userMessage },
	type: Types.SET_USER_MESSAGE
})

export const Creators = {
	setUserMessage
}

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case Types.SET_USER_MESSAGE:
			return { ...state, userMessage: action.payload.userMessage }
		default:
			return state
	}
}
